import { AxiosResponse } from 'axios'
import fileDownload from 'js-file-download'
import React, { useCallback } from 'react'
import useApi from '../../hooks/useApi'
import { Button } from '../../Korbantech/components/Buttons/Button'
import { LibraryItem } from '../../types/LibraryItem'


export const LibraryOscCard = ({ item,download,watch,type }: Props) => {

    const api = useApi()
    
    const handleDownload = useCallback(async ()=>{
            await api.get(`client/library/${type}/${item.id}`, { responseType: 'blob' } )
            .then( (res:AxiosResponse<Blob>) => {
                fileDownload( res.data, `${item.title ? item.title : "ebook"}.${item.extension}` )
            }).catch(console.log)
    },[type,item,api])  
    
    
    const handleSee = useCallback(async ()=>{
        await api.get(`client/library/${type}/${item.id}`)
        .then(res => {
            window.open(res.data.link , '_blank');
        }).catch(console.log)
    },[api,item,type])


    return (
        <div className='mt-3 flex flex-col items-center w-full rounded-md overflow-hidden relative'>
            {download &&
            <div className="absolute w-full z-10 bg-gray-900 h-full top-0 left-0 p-16 flex items-center justify-center bg-opacity-50 opacity-0 hover:opacity-100">
                <Button value="Download" onClick={handleDownload}/>
            </div>
            }
            {watch && 
             <div className="absolute w-full z-10 bg-gray-900 h-full top-0  p-16 left-0 flex items-center justify-center bg-opacity-50 opacity-0 hover:opacity-100">
             <Button value="Ver" onClick={handleSee} />
              </div> 

            }
            <div className='bg-white w-full flex flex-col items-center'>
                {item.image ? <img className='h-40' style={{ width: "auto" }} src={item.image} alt={item.title} /> : <img className='h-40' style={{ width: "auto" }} src={"https://via.placeholder.com/237x129"}
                    alt={item.title}
                />}
                <div className='pl-4 py-2 self-start'>
                    {item.title &&
                        <div className='flex justify-between'>
                            <div className='text-lg font-semibold'>{item.title}</div>
                        </div>
                    }
                    {item.description &&
                        <div className='text-gray-600 text-sm'>
                            {item.description.slice(0, 120)}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

interface Props {
    item: LibraryItem,
    download?:boolean,
    watch?:boolean
    type:"ebooks"|"hints"|"materials"|"videos"
}